<template>
    <div class="sidebar-panel-header">
        <h5 class="sidebar-panel-title" v-text="title"></h5>

        <div class="sidebar-panel-actions">
            <template v-if="showSave">
                <button type="button"
                        :class="styles.BUTTON.PRIMARY"
                        data-test="sidebar-header-save"
                        @click="$emit('save')">
                    Save
                </button>
                <button type="button"
                        :class="styles.BUTTON.INFO"
                        data-test="sidebar-header-save-close"
                        @click="$emit('saveAndClose')">
                    Save & Close
                </button>
            </template>

            <button type="button"
                    class="sidebar-panel-close"
                    title="Close"
                    aria-label="Close"
                    data-test="sidebar-header-close"
                    @click="$emit('close')"
                    v-html="$form.getIcon('close', '24px', '24px', '#000')">
            </button>
        </div>
    </div>
</template>

<script>
    import {STYLE_INJECTION_MIXIN} from "../../../mixins/style-injection-mixin";

    /**
     * Sticky header shared by the four GlobalSidebar panels: title on the left, the actions on the right.
     * It only emits. The body component owns the save / close logic (SIDEBAR_BODY_MIXIN), so the
     * header buttons and the bottom buttons run the exact same code.
     */
    export default {
        name: "SidebarPanelHeader",
        mixins: [STYLE_INJECTION_MIXIN],
        props: {
            title: {
                type: String,
                default: ""
            },

            /**
             * false => only the close button (Add Control has nothing to save)
             */
            showSave: {
                type: Boolean,
                default: true
            }
        }
    }
</script>
